import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/Section";

const Consulting = () => (
  <React.Fragment>
    <Helmet>
      <title>Aspiricity - Consulting Services</title>
    </Helmet>

    <Header>
      <h2>Consulting Services</h2>
    </Header>

    <Section bgColor="bg-light" textColor="text-dark">

      <p className="lead">
        Practical consulting services focused on software quality, modernization, automation, and effective technology delivery.
      </p>

      <p>
        Aspiricity works with organizations and development teams looking to improve software quality, streamline delivery workflows, modernize applications, and strengthen testing and automation practices.
      </p>

      <p>
        Our consulting approach emphasizes practical solutions, collaborative problem solving, and sustainable engineering practices that support long-term product and team success.
      </p>

      <h3>Areas of Focus</h3>

      <p>
        Our services include software testing strategy, quality engineering, AI-powered Testing, Non-Deterministic Testing, Agile and development process improvement, automation consulting, modernization initiatives, and exploratory AI-assisted workflow development.
      </p>

      <p>
        Our services include software testing strategy, quality engineering, AI-powered testing approaches, non-deterministic and AI-assisted system testing, Agile and development process improvement, automation consulting, modernization initiatives, and exploratory AI-assisted workflow development.
      </p>

      <h3>Work with Us</h3>

      <p>
        We value professionalism, transparency, continuous improvement, and long-term client relationships built on trust and measurable results.
      </p>

      <Button as={Link} variant="primary" to="/contact">
        Contact Us
      </Button>

      <br />
    </Section>

    <Footer />
  </React.Fragment>
);

export default Consulting;